import React from 'react'
import Areas from './areas.svg'
function AreasIcon() {
    return <img src={Areas} alt="Areas Icon" />;
}

export default AreasIcon